import { combineReducers } from 'redux';
import { Api } from '../../../core/api';

import qs from 'qs';

const categoriesListApi = new Api({
  namespace: 'CATEGORIES_LIST',
  url: '/internal-intranet/search/categories',
  useEagleApi: true,
});

const checkSlugsApi = new Api({
  useEagleApi: true,
  options: {
    method: 'GET',
  },
});

const categoryItemApi = new Api({
  initialData: {},
  namespace: 'CATEGORY_ITEM',
  useEagleApi: true,
});

const createCategoryApi = new Api({
  namespace: 'CREATE_CATEGORY',
  options: {
    method: 'POST',
  },
  url: `/internal-intranet/categories`,
  useEagleApi: true,
});

const editCategoryApi = new Api({
  namespace: 'EDIT_CATEGORY',
  options: {
    method: 'PUT',
  },
  useEagleApi: true,
});

const deleteCategoryApi = new Api({
  namespace: 'DELETE_CATEGORY',
  options: {
    method: 'DELETE',
  },
  throwable: true,
  useEagleApi: true,
});

export const fetchCategories = ({ search, hash }: any) => {
  let searchPhrase = '';

  if (hash) {
    const searchString = hash.split('#')[1];

    searchPhrase = search
      ? `&search=${searchString}`
      : `?search=${searchString}`;
  }

  const params = qs.parse(search.slice(1));
  const searchParams = qs.parse(searchPhrase?.slice(1) as string);
  const body = JSON.stringify({
    page: +params.page || 0,
    pageSize: +params.limit || 10,
    sort: {
      order: [
        { direction: 'ASC', property: 'title' },
        { direction: 'ASC', property: 'slug' },
      ],
    },
    filter: searchParams.search
      ? {
          filters: [
            {
              property: 'title',
              type: 'containsIgnoreCase',
              value: searchParams.search,
            },
            {
              property: 'slug',
              type: 'containsIgnoreCase',
              value: searchParams.search,
            },
          ],
        }
      : null,
  });

  return categoriesListApi.fetch({
    options: {
      method: 'POST',
      body,
    },
  });
};

export const fetchCategoryInfo = (id: string) =>
  categoryItemApi.fetch({
    url: `/internal-intranet/categories/${id}`,
  });

export const resetCategoryInfo = categoryItemApi.reset;

export const createCategory = (data: any) =>
  createCategoryApi.fetch({ options: { body: JSON.stringify(data) } });

export const editCategory = (id: string, data: any) =>
  editCategoryApi.fetch({
    options: { body: JSON.stringify(data) },
    url: `/internal-intranet/categories/${id}`,
  });

export const deleteCategory = (id: string) =>
  deleteCategoryApi.fetch({
    options: { body: JSON.stringify({ ids: [id] }) },
    url: `/internal-intranet/categories`,
  });

export const checkSlugs = (slug: string) => {
  if (slug) {
    return checkSlugsApi.simpleFetch({
      url: `/internal-intranet/categories/has-slug/${slug}`,
    });
  }
  return false;
};

export const reducer = combineReducers({
  item: categoryItemApi.reducer,
  list: categoriesListApi.reducer,
});
